import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './i18n';
import AppLayout from './components/layout/AppLayout';
import HomePage from './pages/home';
import ExhibitionsPage from './pages/exhibitions/ExhibitionPage';
import ExhibitionDetailPage from './pages/exhibitions/ExhibitionDetailPage';
import AboutPage from './pages/about/AboutPage';
import CareersPage from './pages/careers';
import ContactPage from './pages/contact/ContactPage';
import Loader from './components/Loader/Loader';
import AdminRouter from './admin/AdminRouter'; // Fixed the import path case
import AdminLogin from './admin/pages/LoginPage';
import AOS from 'aos';
import 'aos/dist/aos.css';

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease',
      once: false, // false yapıyoruz ki tekrar tekrar çalışsın
      mirror: true // scroll up yapınca ters animasyon için
    });
  }, []);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, []);

  return (

    <Router>
      <Routes>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/*" element={<AdminRouter />} />
        
        <Route path="/*" element={
          <AppLayout>
            <Routes>
              <Route index element={<HomePage />} />
              <Route path="exhibitions" element={<ExhibitionsPage />} />
              <Route path="exhibition/:exhibitionId" element={<ExhibitionDetailPage />} />
              <Route path="about" element={<AboutPage />} />
              <Route path="careers" element={<CareersPage />} />
              <Route path="contact" element={<ContactPage />} />
            </Routes>
          </AppLayout>
        } />
      </Routes>
      <Loader isLoading={isLoading} />
    </Router>
  );
}

export default App;
